/**
 * A campaign/template tab whose target is gone (trashed or missing).
 * Not "hasn't been selected yet" — restore leaves a live tab selected
 * before selectedSprintId is applied.
 */
export function isDeadContentTab(tab, sprints = []) {
  if (!tab) return false;
  if (tab.type === 'campaign' || tab.type === 'template') {
    return !sprints.some((s) => s.id === tab.targetId && !s.deletedAt);
  }
  return false;
}

/**
 * Only rewrite the main view to Campaigns Atlas when there is no tab,
 * or the highlighted tab points at a deleted campaign/template.
 */
export function shouldRewriteToCampaignsHome({ tabsLength, activeTab, sprints }) {
  if (!tabsLength) return true;
  return isDeadContentTab(activeTab, sprints);
}
